"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dropdown = _interopRequireDefault(require("react-bootstrap/lib/Dropdown"));

var _MenuItem = _interopRequireDefault(require("react-bootstrap/lib/MenuItem"));

var _Glyphicon = _interopRequireDefault(require("react-bootstrap/lib/Glyphicon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var buttonUnsetStyles = {
  textTransform: "unset",
  letterSpacing: "unset",
  height: "unset"
};

var GenomeBrowsersDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(GenomeBrowsersDropdown, _React$Component);

  var _super = _createSuper(GenomeBrowsersDropdown);

  function GenomeBrowsersDropdown(props) {
    _classCallCheck(this, GenomeBrowsersDropdown);

    return _super.call(this, props);
  }

  _createClass(GenomeBrowsersDropdown, [{
    key: "handleChange",
    value: function handleChange(eventKey, event) {
      event.preventDefault();
      this.props.onSelect(eventKey);
    }
  }, {
    key: "_genomeBrowserIcon",
    value: function _genomeBrowserIcon(genomeBrowser) {
      switch (genomeBrowser) {
        case "none":
          return "eye-close";

        default:
          return "eye-open";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var genomeBrowsers = this.props.genomeBrowsers.map(function (genomeBrowserName) {
        return {
          id: genomeBrowserName.replace(/\s+/g, "").toLowerCase(),
          label: "".concat(genomeBrowserName, " genome browser")
        };
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
        id: "genome-browsers-dropdown",
        onSelect: function onSelect(key, e) {
          return _this.handleChange(key, e);
        },
        title: "Choose genome browser"
      }, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"].Toggle, {
        bsSize: "small",
        style: buttonUnsetStyles
      }, /*#__PURE__*/_react["default"].createElement(_Glyphicon["default"], {
        glyph: this._genomeBrowserIcon(this.props.selected)
      }), "\xA0", genomeBrowsers.find(function (gb) {
        return _this.props.selected === gb.id;
      }).label), /*#__PURE__*/_react["default"].createElement(_Dropdown["default"].Menu, {
        bsSize: "small"
      }, genomeBrowsers.map(function (gb) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          style: {
            listStyleImage: "none"
          },
          key: gb.id,
          eventKey: gb.id,
          href: "#"
        }, gb.label);
      }))));
    }
  }]);

  return GenomeBrowsersDropdown;
}(_react["default"].Component);

GenomeBrowsersDropdown.propTypes = {
  genomeBrowsers: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  selected: _propTypes["default"].string,
  onSelect: _propTypes["default"].func
};
var _default = GenomeBrowsersDropdown;
exports["default"] = _default;